import { render, staticRenderFns } from "./ExpenseForm.vue?vue&type=template&id=2dfb2d25"
import script from "./ExpenseForm.vue?vue&type=script&lang=js"
export * from "./ExpenseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports